import styled from '@emotion/styled';
import * as SC from '../../SC/App.sc';

export const Container = styled(SC.FlexColumn)`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
